<div class="relative isolate flex min-h-screen flex-col overflow-x-clip bg-surface-dark">
  <div
    aria-hidden="true"
    class="pointer-events-none absolute inset-x-0 -top-5.25 z-0 h-77.75 bg-linear-[184.77deg,#072437_7.11%,rgba(6,38,58,0)_75.52%]"
  ></div>

  <app-header class="relative z-30" />
  <main class="relative z-20 flex flex-1 min-h-0 flex-col">
    <router-outlet />
  </main>
  <app-footer class="relative z-10" />
</div>
